export default [
    {
    title: 'Разрешения',
    icon: 'CheckSquareIcon',
    children: [
        {
            title: 'По сущностям',
            route: 'user_permission-model',
            action: 'read',
            resource: 'userpermission',
        },
        {
            title: 'По обьектам',
            route: 'user_permission-object',
            action: 'read',
            resource: 'userobjectpermission',
        },
    ]
  },
]
